<template>
  <Modal
    :value="showVip"
    @on-cancel="hideModal"
    :mask-closable="false"
    width="450"
    class-name="vertical-center-modal buyVIP"
    :footer-hide="footerShow"
  >
    <div
      slot="header"
      class="head-title"
    >
      <!-- 头像 -->
      <img
        :src="userInfo.icon"
        class="avator"
      >
      <!--未登录 -->
      <div
        class="user-desc"
        v-if="!userInfo.isLogin"
      >
        <h5 @click="login">立即登录</h5>
        <div class="info"> 登录后购买VIP会员(适用于手机/电脑)</div>
      </div>
      <!-- 已登录 会员-->
      <div
        class="user-desc login-vip"
        v-if="userInfo.isLogin && userInfo.isVip"
      >
        <h5>
          {{userInfo.phone}}
          <img src="@/assets/imgs/vip-sign.png">
          <span
            class="toggleUser"
            @click="login('toggleUser')"
          >切换用户</span>
        </h5>
        <div class="info">
          会员有效期：{{userInfo.vipTime}}
        </div>
      </div>

      <!-- 已登录 非会员 -->
      <div
        class="user-desc login-novip"
        v-if="userInfo.isLogin && !userInfo.isVip"
      >
        <h5> {{userInfo.phone}} <span
            class="toggleUser"
            @click="login('toggleUser')"
          >切换用户</span></h5>
        <div class="info"> 购买vip会员，畅享极致观影（适用于手机/电脑）</div>
      </div>
    </div>
    <div class="vip-list">
      <h3>VIP会员</h3>

      <div class="paybox-list">
        <ul>
          <li
            v-for="(item, key) in vipListView"
            @click="choosePayWay(item)"
            :key="key"
            :class="['pay-item', {current: activePay.service_id === item.service_id}]"
          >
            <!-- 角标 -->
            <i class="corner">
              <img :src="item.corner">
            </i>
            <div class="pay-item-wrap">
              <span class="name">{{item.name}}</span>
              <span class="price"><i class="priceSign">￥</i>{{item.now_price}}</span>
            </div>
          </li>

          <li class="hideLi"></li>
          <li class="hideLi"></li>
        </ul>
      </div>
      <div
        class="pay-desc"
        v-if="userInfo.isLogin"
      >
        <div class="code-payment">扫码支付</div>
        <div class="qrcode-wrap">
          <div ref="qrcode"></div>
          <Spin
            fix
            size="large"
            v-if="qrcodeLoading"
          ></Spin>
        </div>
        <div class="pay-msg-wrap">
          <div class="pay-amount">
            <span class="price">￥ {{activePay.now_price}}</span>
            <span class="former">￥{{activePay.former_price}}</span>
          </div>
          <div class="pay-sup-way">
            支持
            <img src="@/assets/imgs/zhifubao.png">
            <img src="@/assets/imgs/weixin.png">
            扫码支付
          </div>
          <div class="pay-agree">
            <router-link
              to="/vod_agreement.html"
              target="_blank"
            >《暴风影音付费服务协议》</router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="login-footer"
    >
      <Button
        type="primary"
        size="large"
        shape="circle"
        :loading="modal_loading"
        @click="buyVip"
      >立即支付</Button>
    </div>
  </Modal>
</template>

<script>
import UserIcon from '@/assets/imgs/user-by.png'
import cookie from '@/assets/js/cookie'
import apis from '@/assets/js/api'
import '@/assets/js/qrcode.min.js'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('common')

export default {
  name: 'BuyVIp',
  props: {
    showVip: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showVip: function (newIsShow) {
      if (newIsShow) {
        // 同步登录状态
        this.syncLoginStatus()
        // 获取套餐列表
        this.getVipList()
      }
    }
  },
  data () {
    return {
      user_key: 'bf_login_user',
      activePay: {},
      footerShow: true,
      userInfo: {
        isLogin: false, // 是否登录
        phone: '', // 电话号码
        icon: UserIcon, // 用户头像
        nick_name: '', // 用户名称
        isVip: false, // 是否是vip
        vipIcon: '', // 会员标识
        vipTime: '', // vip到期时间
        userId: '', // 用户id
        token: '' // token
      },
      modal_loading: false, // loading
      userIcon: UserIcon, // 用户头像
      vipListView: [], // vip列表
      orderInfo: '', // 查询账单的key
      maxRetryTime: 20, // 最大查询次数
      retryTime: 0, // 当前重试次数
      intervalPayId: 0, // 定时器
      qrcodeLoading: false
    }
  },
  mounted () {
    // 同步登录状态
    this.syncLoginStatus()
  },
  methods: {
    ...mapActions(['vipList', 'preorder', 'orderstatus']),
    // 同步登录状态
    syncLoginStatus () {
      const getLogin = cookie.get(this.user_key)
      if (!getLogin) { // 代表用户没有登录 或者异常
        this.userInfo['isLogin'] = false
        this.userInfo['isVip'] = false
        this.userInfo['icon'] = UserIcon
        this.userInfo.userId = ''
        this.userInfo.token = ''
        this.footerShow = false
      }
      try {
        const info = JSON.parse(getLogin)
        const { user_id, token, userbaseinfo, uservipinfo } = info
        // 是否登录
        if (user_id) {
          this.userInfo['isLogin'] = true
          this.userInfo.userId = user_id
          this.userInfo.token = token
          this.footerShow = true
        }

        // 是否是vip 是的话 图片取会员图片否则默认 >0 代表会员
        if (uservipinfo && uservipinfo['vip']['vip_class'] > 0) {
          this.userInfo['isVip'] = true
          this.userInfo['vipTime'] = uservipinfo['vip']['endtm'].split(' ')[0]
          this.userInfo['vipIcon'] = uservipinfo['vip']['icon']
        }
        if (info['userbaseinfo']) {
          this.userInfo['icon'] = userbaseinfo.user_icon.orig
          this.userInfo['nick_name'] = userbaseinfo.nick_name
          const numLeng = userbaseinfo.phone.length
          this.userInfo['phone'] = userbaseinfo.phone.substring(0, 3) + '***' + userbaseinfo.phone.substring(numLeng - 3)
        }
      } catch (e) {
        this.userInfo['isLogin'] = false
        this.userInfo['isVip'] = false
        this.userInfo['icon'] = UserIcon
        this.userInfo.userId = ''
        this.userInfo.token = ''
      }
    },

    // 获取套餐列表
    getVipList () {
      this.retryTime = 0
      let vipParams = {
        ctype: 'service', // 必选  media-单片 不支持
        renewsupport: 1 // 客户端是否支持连续包月购买
      }
      const getLogin = cookie.get(this.user_key)
      if (getLogin) {
        var info = JSON.parse(getLogin)
        const { user_id, token } = info
        if (user_id) {
          vipParams['user_id'] = user_id
        }
        if (token) {
          vipParams['token'] = token
        }
      }

      vipParams = Object.assign(vipParams, apis.poseidonCommonParams)
      for (let key in vipParams) {
        if (!vipParams[key]) delete vipParams[key]
      }
      this.vipList(vipParams).then(res => {
        const { services } = res
        this.vipListView = services
        this.activePay = services[0]
        if (!getLogin) return
        // 获取套餐的二维码
        this.doPay()
      })
    },

    // 选择某个套餐
    choosePayWay (item) {
      if (item && item.service_id !== this.activePay.service_id) {
        this.activePay = item
        // 如果当前登录
        if (this.userInfo.isLogin) {
          this.retryTime = 0
          this.doPay()
        }
      }
    },

    // 与下单接口 获取二维码
    doPay () {
      this.qrcodeLoading = true
      const { userId, token } = this.userInfo
      const { service_id, now_price } = this.activePay
      let param = {
        user_id: userId, // 用户id
        token: token, // token
        ctype: 'service', // 购买服务 media单片 todo
        ctype_id: service_id, // 服务id
        price: now_price // 价格
      }
      param = Object.assign(param, apis.poseidonCommonParams)
      this.preorder(param).then(res => {
        const { data } = res
        if (data.url) {
          this.orderInfo = data.url.split('key=')[1]
          // 生成二维码
          this.makeCode(data.url)
        }
      }).catch(() => {
        this.qrcodeLoading = false
      })
    },

    // 生成二维码
    makeCode (url) {
      this.$refs.qrcode.innerHTML = ''
      // eslint-disable-next-line no-undef
      var qrcode = new QRCode(this.$refs.qrcode, {
        width: 85,
        height: 85
      })
      qrcode.makeCode(url)
      this.qrcodeLoading = false
      // 开始轮询支付状态
      this.checkPayState((bol) => {
        if (bol) {
          this.$Message.success('支付成功')
          // 关闭模态框
          this.hideModal('login_state_change')
          if (this.$route.query.open) {
            this.$router.replace('/')
          }
        } else {
          this.$Message.error('支付失败，您取消订单或余额不足')
          // 重新获取二维码
          // this.retryTime = 0
          // this.doPay()
        }
      })
    },

    // 检查支付状态
    checkPayState (callback) {
      if (this.intervalPayId) {
        clearTimeout(this.intervalPayId)
      }
      const { userId, token } = this.userInfo
      const { is_renew } = this.activePay
      let param = {
        user_id: userId, // 用户id
        token: token, // token
        ctype: 'service', // 购买服务 media单片 todo
        is_renew: is_renew, // 是否连续包月
        key: this.orderInfo // 二维码链接 后边的key
      }
      param = Object.assign(param, apis.poseidonCommonParams)
      this.orderstatus(param).then(json => {
        // console.log('请求的支付状态', json)
        const res = this.onCheckResult(json, callback)
        if (!res) return
        this.intervalPayId = setTimeout(() => {
          this.checkPayState(callback)
        }, 2000)
      })
    },

    // 支付返回的参数格式化
    onCheckResult (json, cb) {
      if (this.retryTime >= this.maxRetryTime) {
        this.cancelCheckPayState()
        console.warn('pay timeout')
        if (this.showVip && cookie.get(this.user_key)) {
          this.$Message.error('支付信息查询失败，请稍后重试')
        }
        return false
      }

      if (json.data) {
        let payStatus = false
        switch (json.data.order_status) {
          // 支付成功清空 上报字段
          case 'paid':
          case 'success':
            if (cookie.get('pay_ref')) {
              cookie.remove('pay_ref')
            }
            payStatus = true
            this.cancelCheckPayState()
            cb && cb(payStatus)
            break
          case 'unpaid':
          case 'failed':
            payStatus = false
            this.cancelCheckPayState()
            cb && cb(payStatus)
            break
          default:
            break
        }
      }
      this.retryTime += 1
      return true
    },

    // 清空定时器
    cancelCheckPayState () {
      this.retryTime = this.maxRetryTime
      clearTimeout(this.intervalPayId)
    },

    // 立即支付
    buyVip () {
      if (!this.userInfo.isLogin) { // 未登录的话 就先去登录
        this.login()
      } else {
        console.log('立即支付')
      }
    },

    // 立即登录 || 切换用户
    login (type) {
      this.cancelCheckPayState()
      this.$emit('loginModal', type)
    },

    // 关闭模态框
    hideModal (type) {
      this.cancelCheckPayState()
      this.$emit('hideVipModal', type)
    }
  }
}
</script>

<style lang="less" scoped>
.buyVIP {
  .paybox-list {
    margin-top: 15px;
  }
  .vip-list ul {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .vip-list li {
    width: 160px;
    padding: 20px;
    background: rgba(22, 22, 28, 0.04);
    border-radius: 4px;
    border: 1px solid rgba(22, 22, 28, 0.1);
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    cursor: pointer;
    .corner {
      width: 60px;
      position: absolute;
      left: 0px;
      top: 0px;
      img {
        width: 100%;
      }
    }
    .pay-item-wrap {
      text-align: center;
      span {
        display: block;
      }
      span.name {
        letter-spacing: 1px;
        font-size: 16px;
        color: #333333;
        font-weight: 400;
        line-height: 24px;
      }
      span.price {
        font-size: 22px;
        font-weight: bold;
        color: #333333;
        line-height: 35px;
        .priceSign {
          font-size: 16px;
        }
      }
    }
  }

  .vip-list .current {
    background: rgba(255, 227, 168, 0.4);
    border: 1px solid #e1b863;
    .pay-item-wrap {
      span.name,
      span.price {
        color: #572206;
      }
    }
  }

  .pay-desc {
    display: flex;
    margin-top: 10px;
    .code-payment {
      width: 80px;
      height: 24px;
      background: url('~@/assets/imgs/saomabg.png') no-repeat;
      padding: 1px;
      border-radius: 0px 15px 15px 0px;
      color: #572206;
      text-align: center;
    }
    .qrcode-wrap {
      width: 103px;
      height: 103px;
      margin: 0 25px;
      padding: 8px;
      border: 1px solid rgba(51, 51, 51, 0.1);
      position: relative;
    }

    .pay-msg-wrap {
      .pay-amount {
        .price {
          font-size: 24px;
          font-weight: bold;
          color: #ff7127;
          margin-right: 10px;
        }
        .former {
          font-size: 16px;
          text-decoration: line-through;
          color: #e7a51d;
        }
      }

      .pay-sup-way {
        line-height: 35px;
        color: #333333;
        font-weight: 500;
        margin-left: 5px;
        margin-bottom: 5px;
        font-size: 14px;
        img {
          vertical-align: middle;
        }
      }

      .pay-agree {
        a {
          color: #979797;
          letter-spacing: 1px;
          font-size: 13px;
        }
      }
    }
  }
}

.hideLi {
  visibility: hidden;
  padding: 0 !important;
}
.login-footer {
  text-align: center;
  button {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/buyVip.vue